import { getNumericValue } from '../../shared/utils/get-numeric-value.js';
import { MultiMeterBarSegmentProps } from '../types/multi-meter-bar-chart.js';

export const buildSegmentData = (
  segment: MultiMeterBarSegmentProps,
  color: string,
) => {
  const value = getNumericValue(segment.value, segment.valueAccessor);

  const segmentId = `${segment.name}-${value}`;

  return {
    color,
    name: segment.name,
    id: segmentId,
    value,
  };
};
